/**
 * Startseite pro Rolle nach dem Login (UX-Plan 2026-09-14, Phase 1.5).
 *
 * Lehrende landen auf der Kursliste, weil dort jede Aufgabe beginnt
 * (Status pro Kurs, Beitritts-Code, Einstieg in die Planung). Studierende
 * landen ebenfalls auf ihrer Kursliste: Neue kommen mit einem Beitritts-Code
 * in der Hand, Bestehende sehen dort Status und Termin.
 */
export const TEACHER_HOME = '/me/classes/teacher';
export const STUDENT_HOME = '/student/classes';

export function homePathForRole(role: string | null | undefined): string | null {
  if (role === 'teacher') return TEACHER_HOME;
  if (role === 'student') return STUDENT_HOME;
  return null;
}

/** Deutsche Rollenbezeichnung für Profil-Menü und Badges. */
export function roleLabel(role: string | null | undefined): string {
  if (role === 'teacher') return 'Lehrkraft';
  if (role === 'student') return 'Student*in';
  if (role === 'admin') return 'Admin';
  return '';
}
